import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import React from 'react';

function OfficeIcon(props: SvgIconProps) {
  return (
    <SvgIcon width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <defs>
        <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="318ljldmfa">
          <stop stopColor="#3E8BFF" offset="0%" />
          <stop stopColor="#3E8BFF" offset="100%" />
        </linearGradient>
      </defs>
      <path
        d="M11.86 0c.432 0 .846.171 1.151.477.306.305.477.72.477 1.15v3.954h4.884c.899 0 1.628.729 1.628 1.628v11.163c0 .9-.73 1.628-1.628 1.628h-5.567a.71.71 0 0 1-.014 0H1.628c-.432 0-.846-.171-1.15-.477A1.624 1.624 0 0 1 0 18.373V1.627C0 1.196.171.782.477.478.782.17 1.197 0 1.627 0H11.86zm0 1.395H1.628a.233.233 0 0 0-.233.233v16.744a.233.233 0 0 0 .233.233l2.092-.001v-5.348a1.165 1.165 0 0 1 1.164-1.163h3.72a1.166 1.166 0 0 1 1.163 1.163v5.348h2.326V1.629a.233.233 0 0 0-.233-.233zM8.372 13.488H5.116v5.117h3.256v-5.117zm10-6.511h-4.884v11.628h4.884a.233.233 0 0 0 .233-.233V7.21a.233.233 0 0 0-.233-.232zm-1.628 8.372v1.395H15.35V15.35h1.395zm0-3.256v1.395H15.35v-1.395h1.395zM4.651 9.535v1.395H3.256V9.535H4.65zm2.79 0v1.395H6.048V9.535h1.395zm2.792 0v1.395H8.837V9.535h1.396zm6.511-.698v1.396H15.35V8.837h1.395zM4.651 6.28v1.395H3.256V6.28H4.65zm2.79 0v1.395H6.048V6.28h1.395zm2.792 0v1.395H8.837V6.28h1.396zM4.65 3.023V4.42H3.256V3.023H4.65zm2.79 0V4.42H6.048V3.023h1.395zm2.792 0V4.42H8.837V3.023h1.396z"
        fill="url(#318ljldmfa)"
        fillRule="evenodd"
      />
    </SvgIcon>
  );
}

export default OfficeIcon;
